export default {
  methods: {
    async openDangerousActionConfirmBox(msg) {
      // eslint-disable-next-line no-return-await
      return await this.$bvModal.msgBoxConfirm(`${msg}`, {
        title: 'Please Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      });
    },
  },
};
